export const state = {
	currentUser: null,
	referrals: [],
	notifications: [],
};
